export const LIST_SERVICE_ITEM_REQUEST = 'LIST_SERVICE_ITEM_REQUEST'
export const LIST_SERVICE_ITEM_SUCCESS = 'LIST_SERVICE_ITEM_SUCCESS'
export const LIST_SERVICE_ITEM_FAILURE = 'LIST_SERVICE_ITEM_FAILURE'
export const LIST_SERVICE_ITEM_RESET = 'LIST_SERVICE_ITEM_RESET'

export const CREATE_SERVICE_ITEM_REQUEST = 'CREATE_SERVICE_ITEM_REQUEST'
export const CREATE_SERVICE_ITEM_SUCCESS = 'CREATE_SERVICE_ITEM_SUCCESS'
export const CREATE_SERVICE_ITEM_FAILURE = 'CREATE_SERVICE_ITEM_FAILURE'

export const DETAIL_SERVICE_ITEM_REQUEST = 'DETAIL_SERVICE_ITEM_REQUEST'
export const DETAIL_SERVICE_ITEM_SUCCESS = 'DETAIL_SERVICE_ITEM_SUCCESS'
export const DETAIL_SERVICE_ITEM_FAILURE = 'DETAIL_SERVICE_ITEM_FAILURE'

export const UPDATE_SERVICE_ITEM_REQUEST = 'UPDATE_SERVICE_ITEM_REQUEST'
export const UPDATE_SERVICE_ITEM_SUCCESS = 'UPDATE_SERVICE_ITEM_SUCCESS'
export const UPDATE_SERVICE_ITEM_FAILURE = 'UPDATE_SERVICE_ITEM_FAILURE'

export const DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST'
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS'
export const DELETE_SERVICE_FAILURE = 'DELETE_SERVICE_FAILURE'

export const SUMMARY_SERVICE_ITEM_REQUEST = 'SUMMARY_SERVICE_ITEM_REQUEST'
export const SUMMARY_SERVICE_ITEM_SUCCESS = 'SUMMARY_SERVICE_ITEM_SUCCESS'
export const SUMMARY_SERVICE_ITEM_FAILURE = 'SUMMARY_SERVICE_ITEM_FAILURE'

export const SUMMARY_SERVICE_ITEM_WITH_PARENT_SUCCESS = 'SUMMARY_SERVICE_ITEM_WITH_PARENT_SUCCESS'
export const SUMMARY_SERVICE_ITEM_WITH_PARENT_REQUEST = 'SUMMARY_SERVICE_ITEM_WITH_PARENT_REQUEST'
export const SUMMARY_SERVICE_ITEM_WITH_PARENT_FAILURE = 'SUMMARY_SERVICE_ITEM_WITH_PARENT_FAILURE'

export const POSITION_SERVICE_ITEM_REQUEST = 'POSITION_SERVICE_ITEM_REQUEST'
export const POSITION_SERVICE_ITEM_SUCCESS = 'POSITION_SERVICE_ITEM_SUCCESS'
export const POSITION_SERVICE_ITEM_FAIL = 'POSITION_SERVICE_ITEM_FAIL'